"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _withIcon = _interopRequireDefault(require("./withIcon"));
const ClearPrizm = props => _react.default.createElement("svg", (0, _extends2.default)({
  width: "16px",
  height: "16px",
  viewBox: "0 0 16 16"
}, props), _react.default.createElement("g", {
  stroke: "none",
  strokeWidth: "1",
  fillRule: "evenodd"
}, _react.default.createElement("g", {
  transform: "translate(3.000000, 3.000000)"
}, _react.default.createElement("path", {
  d: "M3.58578644,5 L0.292893219,1.70710678 C-0.0976310729,1.31658249 -0.0976310729,0.683417511 0.292893219,0.292893219 C0.683417511,-0.0976310729 1.31658249,-0.0976310729 1.70710678,0.292893219 L4.99961777,3.58540421 L8.29289322,0.292893219 C8.68341751,-0.0976310729 9.31658249,-0.0976310729 9.70710678,0.292893219 C10.0976311,0.683417511 10.0976311,1.31658249 9.70710678,1.70710678 L6.41421356,5 L9.70710678,8.29289322 C10.0976311,8.68341751 10.0976311,9.31658249 9.70710678,9.70710678 C9.31658249,10.0976311 8.68341751,10.0976311 8.29289322,9.70710678 L4.99961777,6.41459579 L1.70710678,9.70710678 C1.31658249,10.0976311 0.683417511,10.0976311 0.292893219,9.70710678 C-0.0976310729,9.31658249 -0.0976310729,8.68341751 0.292893219,8.29289322 L3.58578644,5 Z"
}))));
const ClearMDS = props => _react.default.createElement("svg", (0, _extends2.default)({
  width: "12px",
  height: "12px",
  viewBox: "0 0 22 22"
}, props), _react.default.createElement("path", {
  fillRule: "evenodd",
  d: "M18.7071068,4 L19.4142136,4.70710678 L12.414,11.707 L19.4142136,18.7071068 L18.7071068,19.4142136 L11.707,12.414 L4.70710678,19.4142136 L4,18.7071068 L11,11.707 L4,4.70710678 L4.70710678,4 L11.707,11 L18.7071068,4 Z"
}));
const AbstractClear = ({
  theme,
  ...other
}) => theme.name === 'mds' ? _react.default.createElement(ClearMDS, other) : _react.default.createElement(ClearPrizm, other);
var _default = exports.default = (0, _styledComponents.withTheme)((0, _withIcon.default)('Clear')(AbstractClear));